import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { IconName } from "@formant/ui/component/common/Icon";

import { Menu } from "../common/Menu";
import { ActionButton } from "../Settings/ActionButton";
import * as styles from "./MultiActionButton.scss";

export interface IMultiActionButtonProps {
    actions: IMultiActionButtonAction[];
    bottom?: boolean;
    className?: string;
}

export interface IMultiActionButtonAction<T = any> {
    icon?: IconName;
    label: string;
    checked?: boolean;
    context?: T;
    onSelect: (context: T) => void;
    tooltip?: string;
}

@observer
export class MultiActionButton extends Component<IMultiActionButtonProps> {
    @observable
    private open: boolean = false;

    public render() {
        const { onSelected, onToggle, open, onClose } = this;
        const { actions, bottom, className } = this.props;
        const items = actions.map(({ icon, label, checked, tooltip }) => ({
            icon,
            value: label,
            selected: checked,
            onSelected,
            tooltip,
        }));
        return (
            <div
                className={classnames(styles["multi-button-action"], className)}
            >
                <ActionButton icon="more" onClicked={onToggle} />
                <Menu
                    visible={open}
                    onClose={onClose}
                    items={items}
                    right={true}
                    bottom={bottom}
                />
            </div>
        );
    }

    private onToggle = () => {
        this.open = !this.open;
    };

    private onClose = () => {
        this.open = false;
    };

    private onSelected = (value: string) => {
        const action = this.props.actions.find(_ => _.label === value);
        if (action) {
            const { onSelect, context } = action;
            onSelect(context);
        }
    };
}
